module.exports = __webpack_public_path__ + "img/caret-right-primary.0faea6d4.svg";